import { render, staticRenderFns } from "./GradeList.vue?vue&type=template&id=14dbb4a6&scoped=true"
import script from "./GradeList.vue?vue&type=script&lang=js"
export * from "./GradeList.vue?vue&type=script&lang=js"
import style0 from "./GradeList.vue?vue&type=style&index=0&id=14dbb4a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dbb4a6",
  null
  
)

export default component.exports